import axios from "axios";
import { API_URL } from "../config";

const homepageService = {
    // Carousel
    getSlides: token =>
        axios.get(`${API_URL}/carousels`, {
            headers: { 'alshorja_auth': token }
        }),
    createSlide: (token, formData) =>
        axios.post(`${API_URL}/carousels`, formData, {
            headers: {
                'alshorja_auth': token,
                "Content-Type": "multipart/form-data"
            }
        }),
    deleteSlide: (token, id) =>
        axios.delete(`${API_URL}/carousels/${id}`, {
            headers: { 'alshorja_auth': token }
        }),
    updateSlide: (token, id, data) =>
        axios.put(`${API_URL}/carousels/${id}`, data, {
            headers: { 'alshorja_auth': token }
        }),

    // Blocks
    getBlocks: token =>
        axios.get(`${API_URL}/home-blocks`, {
            headers: { 'alshorja_auth': token }
        }),
    createBlock: (token, data) =>
        axios.post(`${API_URL}/home-blocks`, data, {
            headers: { 'alshorja_auth': token }
        }),
    deleteBlock: (token, id) =>
        axios.delete(`${API_URL}/home-blocks/${id}`, {
            headers: { 'alshorja_auth': token }
        }),
    updateBlock: (token, id, data) =>
        axios.put(`${API_URL}/home-blocks/${id}`, data, {
            headers: { 'alshorja_auth': token }
        })
};

export default homepageService;
